/**
 * 채널별 파생 상태에서 현재 채널 목록에 없는 항목만 제거한다.
 *
 * 제거할 항목이 없으면 원본 객체를 그대로 반환해 React state update가 no-op으로 남게 한다.
 */
export function pruneVideoChannelRecord<T>(
  record: Record<string, T>,
  activeChannelIds: ReadonlySet<string>,
): Record<string, T> {
  const entries = Object.entries(record);
  if (entries.every(([channelId]) => activeChannelIds.has(channelId))) return record;

  return Object.fromEntries(
    entries.filter(([channelId]) => activeChannelIds.has(channelId)),
  ) as Record<string, T>;
}
